"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useService = exports.useMachine = void 0;
var vue_1 = require("vue");
var xstate_1 = require("xstate");
function useMachine(machine, options) {
    if (options === void 0) { options = {}; }
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = __rest(options, ["context", "guards", "actions", "activities", "services", "delays", "state"]);
    var machineConfig = {
        context: context,
        guards: guards,
        actions: actions,
        activities: activities,
        services: services,
        delays: delays
    };
    var createdMachine = machine.withConfig(machineConfig, __assign(__assign({}, machine.context), context));
    var service = xstate_1.interpret(createdMachine, interpreterOptions).start(rehydratedState
        ? xstate_1.State.create(rehydratedState)
        : undefined);
    var state = vue_1.shallowRef(service.state);
    vue_1.onMounted(function () {
        service.onTransition(function (currentState) {
            if (currentState.changed) {
                state.value = currentState;
            }
        });
        state.value = service.state;
    });
    vue_1.onBeforeUnmount(function () {
        service.stop();
    });
    return { state: state, send: service.send, service: service };
}
exports.useMachine = useMachine;
function useService(service) {
    var serviceRef = vue_1.isRef(service) ? service : vue_1.shallowRef(service);
    var state = vue_1.shallowRef(serviceRef.value.state);
    vue_1.watch(serviceRef, function (service, _, onCleanup) {
        state.value = service.state;
        var unsubscribe = service.subscribe(function (currentState) {
            if (currentState.changed) {
                state.value = currentState;
            }
        }).unsubscribe;
        onCleanup(function () { return unsubscribe(); });
    }, {
        immediate: true
    });
    var send = function (event) { return serviceRef.value.send(event); };
    return { state: state, send: send, service: serviceRef };
}
exports.useService = useService;
